// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2JVAY","title":"AfterFrontImage_title__3ydRj"};